<template>
  <v-container
    id="about"
    class="pa-0"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      no-gutters
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-img
          height="calc(100vh - 96px - 156px)"
          src="others/about.jpg"
          gradient="to top, rgba(235, 207, 199, .3), rgba(224, 175, 156, .0)"
        />
      </v-col>

      <v-col
        class="d-block d-md-flex align-center grey lighten-3 pa-6"
        cols="12"
        md="6"
      >
        <v-card
          color="transparent"
          flat
          class="mx-auto px-3 px-md-12"
          max-width="750"
        >
          <h1
            class="lushary--text mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            Привет!
          </h1>
          <h1
            class="lushary--text mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            Я Дарья Lush.
          </h1>
          <p class="grey--text">
            Для меня профессия фотографа — это призвание.
          </p>
          <p class="grey--text">
            Я профессионал и моя задача прочувствовать Ваше настроение и воплотить Ваши идеи в жизнь.
          </p>

          <p class="grey--text">
            Я работаю в Белгороде и Старом Осколе. По Вашему желанию смогу приехать и в другие близлежащие города.
          </p>

          <div class="lushary--text signature">
            Daria Lush
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'About',
  }
</script>

<style lang="sass">
  .signature
    font-family: 'Cedarville Cursive', cursive !important
    font-size: 2rem
    font-style: italic
</style>
